
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/redeem/confirmed",
      function () {
        return require("private-next-pages/redeem/confirmed.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/redeem/confirmed"])
      });
    }
  